module.exports = __webpack_public_path__ + "img/button.7b4a7a0d.png";